import "./App.css";
import "@/index.css";
import "./lib/theme";
import { useEffect } from "react";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { initAnalytics, trackPageView } from "./lib/analytics";
import { AuthProvider } from "./context/AuthContext";
import { CurrencyProvider } from "./context/CurrencyContext";
import Navbar from "./components/Navbar";
import AuthCallback from "./components/AuthCallback";
import ReferralClaimer from "./components/ReferralClaimer";
import ProtectedRoute from "./components/ProtectedRoute";
import Landing from "./pages/Landing";
import Upload from "./pages/Upload";
import Review from "./pages/Review";
import Binder from "./pages/Binder";
import CardDetail from "./pages/CardDetail";
import Billing from "./pages/Billing";
import Guides from "./pages/Guides";
import GuideArticle from "./pages/GuideArticle";
import Showcase from "./pages/Showcase";
import CardShare from "./pages/CardShare";
import Community from "./pages/Community";
import CollectorBinder from "./pages/CollectorBinder";
import Trades from "./pages/Trades";
import Settings from "./pages/Settings";
import SalesLedger from "./pages/SalesLedger";
import AdminReports from "./pages/AdminReports";
import Privacy from "./pages/Privacy";
import Import from "./pages/Import";
import ListEbay from "./pages/ListEbay";

initAnalytics();

function AppRouter() {
  const location = useLocation();
  useEffect(() => {
    trackPageView(location.pathname + location.search);
  }, [location]);
  // Detect session_id synchronously during render to avoid race conditions
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <Navbar />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/upload" element={<ProtectedRoute><Upload /></ProtectedRoute>} />
        <Route path="/review/:jobId" element={<ProtectedRoute><Review /></ProtectedRoute>} />
        <Route path="/binder" element={<ProtectedRoute><Binder /></ProtectedRoute>} />
        <Route path="/card/:cardId" element={<ProtectedRoute><CardDetail /></ProtectedRoute>} />
        <Route path="/billing" element={<ProtectedRoute><Billing /></ProtectedRoute>} />
        <Route path="/guides" element={<Guides />} />
        <Route path="/guides/:slug" element={<GuideArticle />} />
        <Route path="/showcase/:token" element={<Showcase />} />
        <Route path="/flex/:token" element={<CardShare />} />
        <Route path="/community" element={<Community />} />
        <Route path="/collector/:userId" element={<CollectorBinder />} />
        <Route path="/trades" element={<ProtectedRoute><Trades /></ProtectedRoute>} />
        <Route path="/settings" element={<ProtectedRoute><Settings /></ProtectedRoute>} />
        <Route path="/sales" element={<ProtectedRoute><SalesLedger /></ProtectedRoute>} />
        <Route path="/admin/reports" element={<ProtectedRoute><AdminReports /></ProtectedRoute>} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/import" element={<ProtectedRoute><Import /></ProtectedRoute>} />
        <Route path="/list-ebay" element={<ProtectedRoute><ListEbay /></ProtectedRoute>} />
      </Routes>
    </>
  );
}

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <AuthProvider>
          <CurrencyProvider>
            <ReferralClaimer />
            <AppRouter />
            <Toaster />
          </CurrencyProvider>
        </AuthProvider>
      </BrowserRouter>
    </div>
  );
}

export default App;
